import { useParams } from 'react-router-dom'

import { Box, NotFound } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import ExpensesList from 'modules/expenses/components/expenses/List'
import { GroupHeader } from 'modules/expenses/components/groups/GroupHeader'
import { useGroupDetail } from 'modules/expenses/hooks/useGroupDetail'
import { usePayroll } from 'modules/expenses/hooks/usePayroll'
import { useExpenses } from 'modules/expenses/pages/ExpensesContext'
import { EXPENSES_SYNC_CONFIGURATION } from 'modules/expenses/pages/SyncConfiguration'
import { IntegrationsSyncContextProvider } from 'modules/integrations/hooks/SyncContext'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { usePageActions } from './usePageActions'

const GroupDetailPage = () => {
  const { groupId } = useParams()
  const { navigation } = useNavigation()

  const {
    data,
    featureAvailabilities: { reimburseThroughPayroll },
  } = useExpenses()

  const { currentPeriodOpen: currentPayrollPeriodOpen } = usePayroll(
    reimburseThroughPayroll,
    data.payroll
  )

  const { group, loading: loadingGroup } = useGroupDetail({ id: Number(groupId) })
  const { actions, Modals } = usePageActions({
    group,
    currentPayrollPeriodOpen,
    canSetToPaid: data.expenses._policies.expenseSetToPaid.can,
    canRestartApprovalFlow: data.expenses._policies.expenseRestartApprovalFlow.can,
    canOverrideApprovalFlow: data.expenses._policies.expenseOverrideApprovalFlow.can,
  })

  return (
    <>
      {group && <GroupHeader group={group} actions={actions} />}
      <ResponsivePage.Body error={false} loading={loadingGroup} variant="full" showHeader={false}>
        <Modals />
        {group ? (
          <Box gap="s16">
            <IntegrationsSyncContextProvider configuration={EXPENSES_SYNC_CONFIGURATION}>
              <ExpensesList
                group={group}
                back={{ href: navigation.expenses.groups.id.fullPath({ groupId: group.id }) }}
              />
            </IntegrationsSyncContextProvider>
          </Box>
        ) : (
          <NotFound
            title={i18n.t('errors.page_not_found.title')}
            description={i18n.t('errors.page_not_found.description')}
          />
        )}
      </ResponsivePage.Body>
    </>
  )
}

export default GroupDetailPage
